var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-control flex-1"},[_c('label',{staticClass:"cursor-pointer label flex flex-col"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }